module.exports = __webpack_public_path__ + "static/img/左按钮.c167e646.gif";